import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

import { useField } from 'vee-validate'

interface IPropsTheInput {
    type?: string
    placeholder?: string
    modelValue?: string
    inputName?: string
    customClass?: string
    clearable?: boolean
    id?: string
    allowNegative?: boolean
}
interface IEventTheInput {
    (e: 'update:modelValue', modelValue: string): void
}

function setup(__props: any, { emit }: { emit: ({
    (e: 'update:modelValue', modelValue: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { type: string, placeholder: string, modelValue: string, inputName: string, customClass: string, clearable: boolean, id: string, allowNegative: boolean }



const { value, errorMessage, handleBlur, handleChange } = useField(props.inputName, undefined, {
    initialValue: props.modelValue,
})

const inputType = (() => {
    let type = props.type
    if (props.type === 'custom-number') type = 'text'
    return type
})()

const handleClear = () => {
    value.value = ''
    emit('update:modelValue', value.value)
}

const handleEvent = (event: Event) => {
    if (event.target) {
        if (props.type === 'number') {
            const tmpEvent = event.target as HTMLInputElement

            const [integers, decimals] = tmpEvent.value.split('.')
            if (decimals && decimals.length > 2) {
                tmpEvent.value = `${integers}.${decimals.slice(0, 2)}`
            }
        }

        if (props.type === 'custom-number') {
            const tmpEvent = event.target as HTMLInputElement

            // allow numbers and only one comma or dot
            let dotsCounter = 0
            let dashCounter = 0

            let tmp = tmpEvent.value
                .replace(/[,]/g, '.')
                .replace(/[.]/g, match => (++dotsCounter === 2 ? '' : match))
                .replace(/[-]/g, match => {
                    let valueToReturn = ''
                    const dashOnFirstPlace = tmpEvent.value.charAt(0) === '-'

                    if (props.allowNegative && dashOnFirstPlace && ++dashCounter === 1) {
                        valueToReturn = match
                    } else {
                        valueToReturn = ''
                    }

                    return valueToReturn
                })
                .replace(/[^0-9,.-]/g, '')

            const [integers, decimals] = tmp.split('.')
            if (decimals && decimals.length > 2) {
                tmp = `${integers}.${decimals.slice(0, 2)}`
            }

            tmpEvent.value = tmp
        }

        handleChange(event)
        emit('update:modelValue', value.value)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(__props.type === 'textarea' ? 'textarea' : 'input'), _mergeProps(_ctx.$attrs, {
      id: props.id,
      name: __props.inputName,
      type: _unref(inputType),
      placeholder: __props.placeholder,
      value: _unref(value),
      class: ["p-4 leading-none w-full border border-gray-stroke", { 'pb-3 mb-8': !_unref(errorMessage), 'cursor-not-allowed': _ctx.$attrs.disabled }],
      step: ".01",
      onInput: handleEvent,
      onBlur: _unref(handleBlur)
    }), null, 16, ["id", "name", "type", "placeholder", "value", "class", "onBlur"])),
    (props.clearable)
      ? (_openBlock(), _createElementBlock("svg", {
          key: 0,
          class: "cursor-pointer text-dark-gray opacity-30 h-6 w-6 absolute top-3 right-2 transition-opacity duration-300 hover:opacity-100",
          xmlns: "http://www.w3.org/2000/svg",
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor",
          onClick: handleClear
        }, _hoisted_3))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("p", { class: "text-red" }, _toDisplayString(_unref(errorMessage)), 513), [
      [_vShow, _unref(errorMessage)]
    ])
  ]))
}
}


const __default__ = {
    inheritAttrs: false,
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    type: { type: String, required: false, default: 'text' },
    placeholder: { type: String, required: false, default: '' },
    modelValue: { type: String, required: false, default: '' },
    inputName: { type: String, required: false, default: '' },
    customClass: { type: String, required: false, default: '' },
    clearable: { type: Boolean, required: false, default: false },
    id: { type: String, required: false, default: '' },
    allowNegative: { type: Boolean, required: false, default: false }
  },
  emits: ["update:modelValue"],
  setup})